import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { OptionItemBaseProps } from "./OptionItem.types";

export const optionItemContainerCSS = css({
  width: "100%",

  paddingLeft: vars.spacing[3],
  paddingRight: vars.spacing[3],

  borderRadius: vars.rounded.medium,

  "[aria-checked='true'] &": {
    backgroundColor: vars.semantic.color.actionPrimaryTonal,
  },

  "&:disabled": {
    color: vars.semantic.color.textDisabled,
  },

  "&:not(:disabled):not([aria-checked='true'] &):hover": {
    backgroundColor: vars.semantic.color.actionSecondaryHover,
  },
});

export const optionItemBaseButtonCSS = ({
  size = "default",
}: Pick<OptionItemBaseProps, "size">) => {
  const paddingY = vars.spacing[size === "default" ? 2 : 3];
  return css({
    flex: 1,
    width: "100%",

    paddingTop: paddingY,
    paddingBottom: paddingY,

    textAlign: "left",
  });
};

export const optionItemCheckboxCSS = css({
  width: "100%",

  paddingTop: vars.spacing["15"],
  paddingBottom: vars.spacing["15"],
});
